import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ManoshalaCareService from "../../services/ManoshalaCare";
import { SingleCareRow } from "../../components/List/SingleCareRow";
import { useToast } from "@chakra-ui/react";
export const CareList = () => {
  const token = localStorage.getItem("logged_in_user_token");
  const navigate = useNavigate();
  const toast = useToast();
  const [list, setList] = useState<any>();

  const fetchData = async () => {
    ManoshalaCareService.getCares(token)
      .then((res: any) => {
        setList(res.data.data);
      })
      .catch((error: any) => {
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <div className="main-wrapper">
        <div className="page_title py-2">Manoshala Care - Support</div>

        <div className="p-4">
          {/* Main secttion */}
          <div className="main-section">
            <table className="table">
              <thead>
                <tr>
                  <th>User Id</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Concerns</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {list && list.length > 0 ? (
                  list.map((el: any) => (
                    <SingleCareRow key={el._id} props={el} />
                  ))
                ) : (
                  <h1 className="no-data">No Data Found</h1>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
